<!--产品定制-我的图库-->
<template>
  <div class="image-store">
    <Breadcrumb></Breadcrumb>
    <div class="common-limit line-height-40">
      <div class="form-body">
        <el-form
          ref="form"
          :model="queryParams"
          label-width="80px"
          size="small"
        >
          <el-row :gutter="24">
            <!-- <el-col :span="8">
              <el-form-item label="图库来源：" prop="mapSource">
                <el-radio-group v-model="queryParams.mapSource">
                  <template v-for="(value, key) in dictData['map_source']">
                    <el-radio :label="key" :key="key"> {{ value }}</el-radio>
                  </template>
                </el-radio-group>
              </el-form-item>
            </el-col> -->
            <el-col :span="8">
              <el-form-item label="图片形式：" prop="mapShape">
                <el-select clearable v-model="queryParams.mapShape">
                  <template v-for="(value, key) in dictData['map_shape']">
                    <el-option
                      :key="value.value"
                      :label="value.label"
                      :value="value.value"
                    ></el-option>
                  </template>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="图片格式：" prop="mapFormat">
                <el-input v-model="queryParams.mapFormat" clearable />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="图片分类：" prop="typeId">
                <!-- <el-select clearable  v-model="queryParams.typeId">
                  <template v-for="(value, key) in typeIdMap">
                     <el-option
                      :key="value.value"
                      :label="value.label"
                      :value="value.value"
                    ></el-option>
                  </template>
                </el-select> -->
                <TreeSelect
                  :props="treeSelectProps"
                  :options="typeIdTree"
                  @getValue="getTreeNodeId"
                  v-model="queryParams.typeId"
                  ref="childSelTree"
                  style="width:100%"
                ></TreeSelect>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item label="图片编号：" prop="mapId">
                <el-input v-model="queryParams.mapId" clearable />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="图片名称：" prop="picName">
                <el-input v-model="queryParams.picName" clearable />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="上传时间：" prop="time">
                <el-date-picker
                  v-model="queryParams.time"
                  type="daterange"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                :picker-options="pickerOptions"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="24" class="btn-bar-right">
              <el-button type="primary" size="small" @click="loadData"
                >搜索</el-button
              >
              <el-button size="small" @click="resetForm">重置</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>

    <div class="form-body">
      <div style="overflow:hidden;">
        <span style="float:left">
          <el-button size="small" type="warning" @click="jumpToStore"
            >返回图库</el-button
          >
          <el-button
            style="margin-left: 10px"
            size="small"
            type="success"
            icon="el-icon-delete"
            :disabled="!checkList.length > 0"
            @click="batchRecoverImg"
            >恢复</el-button
          >
          <el-button
            type="warning"
            size="small"
            :disabled="!checkList.length > 0"
            @click="batchRemoveImg"
            >彻底删除</el-button
          >
        </span>
        <pagination
          v-show="total > 0"
          :total="total"
          :page.sync="queryParams.pageNum"
          :limit.sync="queryParams.pageSize"
          @pagination="loadData"
          :layout="'slot, total, sizes, prev, pager, next, jumper'"
        >
        </pagination>
      </div>
      <el-table
        :data="tableData"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          v-if="queryParams.type !== 2"
          type="selection"
          width="55"
          align="center"
        ></el-table-column>
        <el-table-column
          width="186px"
          label="图片编号"
          prop="mapId"
        ></el-table-column>
        <el-table-column label="图片">
          <template slot-scope="scope">
            <el-col style="width: 300px">
              <el-popover placement="right" trigger="hover">
                <img
                  class="img-big"
                  width="300px"
                  height="300px"
                  :src="
                    `${scope.row.picUrl}?x-oss-process=image/resize,m_fill,h_300,w_300`
                  "
                />
                <img
                  slot="reference"
                  class="img-big"
                  width="100px"
                  height="100px"
                  :src="
                    `${scope.row.picUrl}?x-oss-process=image/resize,m_fill,h_100,w_100`
                  "
                />
              </el-popover>
            </el-col>
          </template>
        </el-table-column>
        <el-table-column label="图片名称">
          <template slot-scope="scope">
            <el-row
              type="flex"
              justify="space-between"
              style="height:40px;line-height: 40px;"
            >
              <div>
                {{ scope.row.picName }}
              </div>
            </el-row>
          </template>
        </el-table-column>
        <el-table-column label="图片规格">
          <template slot-scope="scope">
            <div>
              尺寸：{{ scope.row.picWidth }} x {{ scope.row.picHeight }}
            </div>
            <div>形状：{{ dictMap["map_shape"][scope.row.mapShape] }}</div>
            <div>格式：{{ scope.row.mapFormat }}</div>
            <div>大小：{{ scope.row.fileSize }}</div>
          </template>
        </el-table-column>
        <el-table-column label="图片分类">
          <template slot-scope="scope">
            <span>{{ typeIdMap[scope.row.typeId] }}</span>
          </template>
        </el-table-column>
        <el-table-column label="出单数" prop="orderNum"></el-table-column>
        <el-table-column label="上传者" prop="operNo"></el-table-column>
        <el-table-column label="上传时间" prop="createTime"></el-table-column>
      </el-table>
      <pagination
        class="bottom-sticky"
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="loadData"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import Breadcrumb from "@/components/common/Breadcrumb"
import TreeSelect from "@/components/common/treeSelect"
import {
  listImgMap,
  listImgMapType,
  getImgMapTypeTree,
  addImgMap,
  editImgMap,
  deleteImgMap,
} from "@/api/customProduct/imageStore"
export default {
  name: "imageStore",
  components: { Breadcrumb, TreeSelect },
  data() {
    return {
      treeSelectProps: {
        value: "typeId", // ID字段名
        label: "typeName", // 显示名称
        children: "childrenTree", // 子级字段名
      }, // 图片分类
      typeIdMap: {},
      typeIdTree: [],
      queryParams: {
        mapSource: undefined,
        mapShape: undefined,
        mapFormat: undefined,
        yesOrNo: undefined,
        typeId: undefined,
        time: [],
        mapId: undefined,
        picName: undefined,
        beginTime: undefined,
        endTime: undefined,
        sortType: undefined,
        delFlag: "0",
        pageSize: 30,
        pageNum: 1,
      },
      loading: false,
      total: 0,
      tableData: [],
      checkList: [], //选中的图片
    }
  },
  computed: {
    ...mapGetters(["dictData", "dictMap", "nginx", "user"]),
  },
  created() {
    this.loadData()
    this.getImgMapTypeTree()
    this.getTypeIdMap()
  },
  watch: {
    checkList() {
      if (this.checkList.length == 0) {
        this.isCheckAll = false
      }
    },
  },
  methods: {
    /**查询分类列表 */
    async getTypeIdMap() {
      const { rows } = await listImgMapType()
      if (rows) {
        let typeIdMap = {}
        rows.map((item) => {
          typeIdMap[item.typeId] = item.typeName
        })
        this.typeIdMap = typeIdMap
      }
    },
    getTreeNodeId(val) {
      this.queryParams.typeId = val
    },
    /**查询分类树 */
    async getImgMapTypeTree() {
      let type = "01"
      if (this.user.userType == "00") {
        type = "01"
      } else {
        type = "02"
      }
      const { data } = await getImgMapTypeTree({ type })
      if (data) {
        this.typeIdTree = data
        this.classificationTreeData = data
      }
    },
    /**列表查询 */
    loadData() {
      let _self = this
      this.startLoading()
      _self.queryParams.beginTime = _self.queryParams.time[0]
      _self.queryParams.endTime = _self.queryParams.time[1]
      let params = Object.assign({}, _self.queryParams)
      delete params["time"]
      if (this.user.userType == "00") {
        params.mapSource = "01"
      } else {
        params.mapSource = "02"
      }
      listImgMap(params)
        .then((res) => {
          _self.total = res.total
          _self.tableData = res.rows
          this.endLoading()
        })
        .catch((err) => {
          console.error(err)
          this.endLoading()
        })
    },

    resetForm() {
      this.$refs["form"].resetFields()
    },
    //选中所有行
    checkAll(val) {
      this.isIndeterminate = false
      if (val) {
        this.$refs.imgStoreTab.toggleAllSelection()
      } else {
        this.$refs.imgStoreTab.clearSelection()
      }
    },
    /**彻底删除图片 */
    batchRemoveImg() {
      let _self = this
      let ids = []
      _self.checkList.forEach((item) => {
        ids.push(item.mapId)
      })
      _self.$confirm("您确定要删除吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "再想想",
        })
        .then((type) => {
          if (type == "confirm") {
            deleteImgMap({ mapId: ids.join(",") })
              .then((res) => {
                if (res.code == 200) {
                  _self.$message.success("删除成功！")
                  _self.loadData()
                }
              })
              .catch((err) => {
                console.log(err)
              })
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    /**批量恢复图片 */
    batchRecoverImg() {
      let _self = this
      let ids = []
      _self.checkList.forEach((item) => {
        ids.push(item.mapId)
      })
      _self.$confirm("您确定要恢复吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "再想想",
        })
        .then(async (type) => {
          if (type == "confirm") {
            for (let index = 0; index < ids.length; index++) {
              let params = Object.assign({}, { mapId: ids[index] })
              params.delFlag = "1"
              await editImgMap(params)
            }
            _self.$message.success("恢复成功！")
            _self.fileNameVisible = false
            _self.loadData()
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    //行勾选事件
    handleSelectionChange(val) {
      this.isIndeterminate =
        val.length > 0 && val.length < this.tableData.length
      this.isCheckAll = val.length === this.tableData.length
      this.checkList = val
    },
    turnWay(e) {
      var classVal = e.target.className
      if (classVal == "el-icon-caret-top") {
        e.target.setAttribute("class", "el-icon-caret-bottom")
        this.queryParams.sortType = "desc"
      } else {
        e.target.setAttribute("class", "el-icon-caret-top")
        this.queryParams.sortType = "asc"
      }
      this.loadData()
    },
    jumpToStore() {
      this.$router.go(-1)
    },
  },
}
</script>

<style scoped>
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 13px;
}
.btn-bar-right {
  text-align: right;
}
</style>
